/**
 * 平滑滚动到指定位置
 * @param {number} to - 目标滚动位置
 * @param {number} duration - 滚动持续时间（毫秒）
 */
export function scrollTo(to, duration = 500) {
  const start = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  const distance = to - start
  const startTime = +new Date()

  // 缓动函数
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
  }

  const timer = setInterval(() => {
    const time = +new Date() - startTime
    const progress = Math.min(time / duration, 1)
    const value = easeInOutQuad(progress, start, distance, duration)

    window.scrollTo(0, value)

    if (progress === 1) {
      clearInterval(timer)
    }
  }, 16)
}
